export const FETCH_ADVERTISINGS = 'FETCH_ADVERTISINGS';
export const FETCH_ADVERTISINGS_START = 'FETCH_ADVERTISINGS_START';
export const FETCH_ADVERTISINGS_SUCCESS = 'FETCH_ADVERTISINGS_SUCCESS';
export const FETCH_ADVERTISINGS_FAIL = 'FETCH_ADVERTISINGS_FAIL';


